/* eslint-disable max-len,import/newline-after-import,no-restricted-globals */
import tinymce from 'tinymce';
import 'tinymce/themes/silver';
import EventBus from '@/EventBus';
import ApplicationEventTypes from '@/mixins/ApplicationEventTypes';
import { GUIToTinyMCECommandsDictionary, TextCommandTypes } from '@/mixins/TextCommandTypes';

export default {
  methods: {
    async setupActiveEditor() {
      const targetId = this.activeObject.Id;
      const target   = document.getElementById(targetId);
      if (!this.allTextEditorList[targetId]) { this.activeEditor = await this.enableEditor(target.firstElementChild); } else { this.activeEditor = this.allTextEditorList[targetId]; }

      this.activeEditor.targetElm.textContent.toLowerCase() == 'enter text here' && this.activeEditor.selection.select(this.activeEditor.targetElm, true);

      const textDiv           = document.getElementById(`editor-${targetId}`);
      textDiv.contentEditable = true;
      textDiv.focus();
      target.classList.add('focus-text-editor');
      this.activeObject.isEditorEnable  = true;
      this.moveableObj.target           = [];
      this.selectO.toggleContinueSelect = '';
    },
    enableEditor(target) {
      const editorList     = this.allTextEditorList;
      const debounceMethod = _.debounce(() => EventBus.$emit('GetTextSelectionProperties'), 300);
      if (tinyMCE.get(target.id)) {
        tinyMCE.get(target.id).destroy();
      }
      return new Promise((resolve, reject) => {
        tinymce.init({
          target,
          browser_spellcheck:      true,
          inline:                  true,
          menubar:                 false,
          toolbar:                 false,
          skin:                    false,
          extended_valid_elements: 'font[style]',
          formats:                 {
            alignleft: [
              { selector: 'li', classes: 'li-left-align', styles: { 'text-align': 'left' } },
              { selector: 'p,h1,h2,h3,h4,h5,h6,td,th,div,ul,ol,table,img,audio,video', styles: { 'text-align': 'left' } },
            ],
            aligncenter: [
              { selector: 'li', classes: 'li-center-align', styles: { 'text-align': 'center' } },
              { selector: 'p,h1,h2,h3,h4,h5,h6,td,th,div,ul,ol,table,img,audio,video', styles: { 'text-align': 'center' } },
            ],
            alignright: [
              { selector: 'li', classes: 'li-right-align', styles: { 'text-align': 'right' } },
              { selector: 'p,h1,h2,h3,h4,h5,h6,td,th,div,ul,ol,table,img,audio,video', styles: { 'text-align': 'right' } },
            ],
            alignfull: [
              { selector: 'li', classes: 'li-justify-align', styles: { 'text-align': 'justify' } },
              { selector: 'p,h1,h2,h3,h4,h5,h6,td,th,div,ul,ol,table,img,audio,video', styles: { 'text-align': 'justify' } },
            ],
            underline: { inline: 'u' },
          },
        })
          .then((editor) => {
            if (!editor[0]) { return; }
            const ed = editor[0];
            ed.on('selectionChange', () => {
              if (ed.hasFocus()) { debounceMethod(); }
            });
            ed.on('BeforeAddUndo', () => false); // disabling tinymce Undo
            ed.on('Paste', (e) => {
              if (ed.hasFocus()) {
                e.preventDefault();
                const content = ((e.originalEvent || e).clipboardData || window.clipboardData).getData('Text');
                ed.execCommand('mceInsertContent', false, content);
              }
            }); // disabling tinymce Undo
            editorList[target.parentNode.id] = ed;
            EventBus.$emit(ApplicationEventTypes.ProductLoadingEvents.UPDATE_HTML_AFTER_ENABLE_EDITOR, {
              html: ed.getContent(),
              id:   target.parentNode.id,
            });
            return resolve(ed);
          })
          .catch((err) => {
            console.log('error in initializing tinyMCE', err);
            reject(err);
          });
      });
    },
    checkBasicConditions(value) {
      // TODO: Always send string yo this function
      if (value === undefined || value === null || (typeof value === 'string' && !value.length > 0) || (typeof value === 'number' && isNaN(value))) { return false; }
      return true;
    },
    // TODO: Convert to Const & Mixin
    onUpdateTextProperties(data) {
      const { activeObject } = this;

      if (this.activeEditor && data.commandType === TextCommandTypes.TinyMceCommand) {
        this.activeEditor.execCommand(data.command, false, data.value);
        if (data.command == 'JustifyCenter' || data.command == 'JustifyRight' || data.command == 'JustifyLeft' || data.command == 'JustifyFull') { this.changeHorizontalAlign({ command: data.command }); }
        if ((data.command == 'FontSize') || (data.command == 'LineHeight') || (data.command == 'FontName')) {
          this.setParentHeightAccordingToText(activeObject);
        }
        if ((this.isWholeTextSelected(this.activeEditor)) && ((data.command == 'forecolor') || (data.command == 'FontSize') || (data.command == 'FontName') || (data.command == 'LineHeight'))) {
          const propertyName                            = GUIToTinyMCECommandsDictionary[data.command];
          activeObject.valuesForLeftPanel[propertyName] = data.value;
          activeObject[propertyName]                    = data.value;
        }

        if (data.command === 'Bold' && !data.value && this.activeEditor.selection.getNode().tagName === 'SPAN') {
          this.removeAllPendingTag(this.activeEditor.selection.getNode(), 'strong');
        }
        if (data.command === 'Underline' && !data.value && this.activeEditor.selection.getNode().tagName === 'SPAN') {
          this.removeAllPendingTag(this.activeEditor.selection.getNode(), 'u');
        }

        this.applyStyleToLi();
      }
      if (!this.activeEditor || data.commandType !== TextCommandTypes.TinyMceCommand) {
        this.activeObject && this.applyPropertiesToParent(data);
      }
      setTimeout(() => {
        EventBus.$emit(ApplicationEventTypes.ObjectSelectionEvents.UPDATED);
      }, 5);
      setTimeout(() => {
        data.command == 'forecolor' && (EventBus.$emit('updateProductColor'));
      }, 500);
    },
    removeAllPendingTag(element, tag) {
      const strongList = element.querySelectorAll(tag);
      Array.prototype.forEach.call(strongList, (strong) => {
        strong.outerHTML = strong.innerHTML;
      });
      this.activeEditor.selection.select(element);
    },
    addingTextEditor({ id, editor }) {
      editor && (this.allTextEditorList[id] = editor);
    },
    async applyPropertiesToParent(data) {
      console.log('Applying propert to parent');
      const { activeObject } = this;
      const propertyName     = GUIToTinyMCECommandsDictionary[data.command];

      if (data.commandType === TextCommandTypes.VerticalAlignmentCommand) {
        activeObject[data.command]                    = data.value;
        activeObject.valuesForLeftPanel[data.command] = data.value;
      } else if (data.commandType === TextCommandTypes.LineHeightCommand) {
        activeObject.valuesForLeftPanel[propertyName] = data.value;
        activeObject[propertyName]                    = data.value;
      } else {
        const targetId = this.targets[0].id;
        if (!this.allTextEditorList[targetId]) {
          this.activeEditor = await this.enableEditor(this.targets[0].firstElementChild);
        } else {
          this.activeEditor = this.allTextEditorList[targetId];
        }
        const { activeEditor } = this;
        if (activeEditor) {
          activeEditor.selection.select(activeEditor.targetElm, true);
          activeEditor.execCommand(data.command, false, data.value);
          if (data.command === 'forecolor') {
            this.applyStyleToFontTag({
              property: 'color',
              value:    data.value,
            }, this.activeEditor.targetElm.parentNode);
          }
          data.command === 'FontSize' && this.applyStyleToFontTag({
            property: 'fontSize',
            value:    data.value,
          }, this.activeEditor.targetElm.parentNode);
          data.command === 'FontName' && this.applyStyleToFontTag({
            property: 'fontFamily',
            value:    data.value,
          }, this.activeEditor.targetElm.parentNode);


          this.applyStyleToLi();
          activeEditor.selection.collapse();
        }
        this.targets[0].firstElementChild.blur();
        this.activeEditor                             = null;
        activeObject.valuesForLeftPanel[propertyName] =  data.value;
        // activeObject[propertyName]                    = data.value;
        if (propertyName === 'fontSize' || propertyName === 'fontFamily' || propertyName === 'color' || propertyName === 'lineSpacing') {
          activeObject[propertyName] = data.value;
        }
        (data.command === 'JustifyLeft' || data.command === 'JustifyCenter' || data.command === 'JustifyFull' || data.command === 'JustifyRight') && this.changeHorizontalAlign(data);
        if (activeObject) {
          this.setParentHeightAccordingToText(activeObject);
          const editor              = document.getElementById(`editor-${activeObject.Id}`);
          activeObject.modifiedHtml = activeObject.Value  = (editor && editor.querySelectorAll('li').length) ? editor.innerHTML : activeEditor.getContent();// tinymce isn't
          // activeObject.modifiedHtml = activeEditor.getContent();
        }
      }
      setTimeout(() => {
        this.emitUndoRedoRequest('called by text property change');
      }, 10);
    },
    isWholeTextSelected(activeEditor) {
      const selectedText = activeEditor.selection.getContent({ format: 'text' }).replaceAll('\n', '').trim();
      const wholeText    = activeEditor.targetElm.innerText.replaceAll('\n', '').trim();
      return wholeText == selectedText;
    },
    changeHorizontalAlign(data) {
      this.activeObject.valuesForLeftPanel.isJustifyLeft   = this.activeObject.isJustifyLeft   = data.command === 'JustifyLeft';
      this.activeObject.valuesForLeftPanel.isJustifyRight  = this.activeObject.isJustifyRight  = data.command === 'JustifyRight';
      this.activeObject.valuesForLeftPanel.isJustify       = this.activeObject.isJustify       = data.command === 'JustifyFull';
      this.activeObject.valuesForLeftPanel.isJustifyCenter = this.activeObject.isJustifyCenter = data.command === 'JustifyCenter';
    },
    removeTagsStyle(selectedElement) {
      const allStyleTags = selectedElement.querySelectorAll('U , STRONG , EM');
      if (allStyleTags.length) {
        for (let t = 0; t < allStyleTags.length; t++) {
          if (allStyleTags[t].style) {
            allStyleTags[t].removeAttribute('style');
          }
        }
      }
    },
    applyStyleToLi() {
      if (this.activeEditor) {
        const selectedElement = this.activeEditor.targetElm.parentNode;
        const selectedTag     = this.activeEditor.selection.getNode();

        if (selectedElement) {
          this.removeTagsStyle(selectedElement);
          const allLi       = selectedElement.getElementsByTagName('LI');
          const paddingLeft = 0;
          if (allLi.length) {
            for (let i = 0; i < allLi.length; i++) {
              const liInnerSpan = allLi[i].getElementsByTagName('SPAN');
              if (liInnerSpan) {
                const computedStyles = liInnerSpan.length ? window.getComputedStyle(liInnerSpan[0]) : null;
                if (computedStyles) {
                  allLi[i].style.color      = computedStyles.getPropertyValue('color');
                  allLi[i].style.fontSize   = computedStyles.getPropertyValue('font-size');
                  allLi[i].style.fontFamily = computedStyles.getPropertyValue('font-family');
                  // allLi[i].style.lineHeight            = computedStyles.getPropertyValue('line-height');
                  allLi[i].parentNode.style.lineHeight =  parseFloat(computedStyles.getPropertyValue('line-height')) / parseFloat(allLi[i].style.fontSize);
                  allLi[i].parentNode.style.fontSize   =   computedStyles.getPropertyValue('font-size');
                  allLi[i].dataset.mceStyle            = `color: ${allLi[i].style.color}; font-size: ${allLi[i].style.fontSize}; font-family: ${allLi[i].style.fontFamily}; list-style-position: ${allLi[i].style.listStylePosition}; word-break: ${allLi[i].style.wordBreak};line-height: ${allLi[i].parentNode.style.lineHeight};`;
                  if (selectedTag.isSameNode(allLi[i].parentNode.parentNode)) {
                    allLi[i].parentNode.parentNode.style.fontSize = allLi[i].style.fontSize;
                  }
                }
              }
            }
          }
        }
      }
    },
    applyStyleToFontTag(data, selectedElement) {
      if (this.activeEditor && data) {
        if (selectedElement) {
          const fonts = selectedElement.getElementsByTagName('font');
          for (let fontIndex = 0; fontIndex < fonts.length; fontIndex++) {
            fonts[fontIndex].style[data.property] = data.value;
          }
        }
      }
    },
    findPrentSubSup(node, id) {
      if (node && (node.tagName === 'SUP' || node.tagName === 'SUB')) { return true; } if (node && node.id === id) { return false; }
      return this.findPrentSubSup(node.parentNode, id);
    },
    getSelectedNode(activeEditor) {
      if (activeEditor) {
        if (this.isWholeTextSelected(activeEditor)) { return tinyMCE.DOM.get(this.activeObject.Id).children[0]; }
        return activeEditor.selection.getNode();
      }

      return tinyMCE.DOM.get(this.activeObject.Id).children[0];
    },
    getTextSelectionProperties() {
      const i                              = 0;
      const { activeEditor, activeObject } = this;
      if (!activeObject) { return; }
      if (tinyMCE.DOM.get(activeObject.Id).style.overflowY !== 'scroll') { this.setParentHeightAccordingToText(activeObject); }
      const node = this.getSelectedNode(activeEditor);// activeEditor  ? ((this.isWholeTextSelected(activeEditor) ? tinyMCE.DOM.get(activeObject.Id).children[0] : activeEditor.selection.getNode()) : tinyMCE.DOM.get(activeObject.Id).children[0];

      const list        = tinyMCE.DOM.getParent(node, 'ul,ol');
      const isBold      = (activeEditor) ? activeEditor.queryCommandState('Bold') : (parseInt(tinyMCE.DOM.getStyle(node, 'font-weight', true)) > 400);
      const isItalic    = (activeEditor) ? activeEditor.queryCommandState('Italic') : (tinyMCE.DOM.getStyle(node, 'font-style', true) === 'italic');
      const isUnderline = (activeEditor) ? activeEditor.queryCommandState('Underline') : (tinyMCE.DOM.getStyle(node, 'text-decoration', true).includes('underline'));
      let fontSize      =  parseFloat(tinyMCE.DOM.getStyle(node, 'font-size', true)); // (activeEditor) ? parseFloat(activeEditor.queryCommandValue('FontSize')) :
      const lineSpacing = parseFloat(tinyMCE.DOM.getStyle(node, 'line-height', true)) / fontSize;
      if (this.findPrentSubSup(node, activeObject.Id)) {
        fontSize = parseFloat(activeEditor.queryCommandValue('FontSize'));
      }
      const selectedColor = (activeEditor) ? activeEditor.queryCommandValue('ForeColor') : tinyMCE.DOM.getStyle(node, 'color', true);
      const temp          = {
        fontFamily:      tinyMCE.DOM.getStyle(node, 'font-family', true),
        fontSize,
        lineSpacing,
        color:           selectedColor,
        isBold,
        isItalic,
        isUnderline,
        isJustifyCenter: tinyMCE.DOM.getStyle(node, 'text-align', true) === 'center',
        isJustifyLeft:   tinyMCE.DOM.getStyle(node, 'text-align', true) === 'left',
        isJustifyRight:  tinyMCE.DOM.getStyle(node, 'text-align', true) === 'right',
        isJustify:       tinyMCE.DOM.getStyle(node, 'text-align', true) === 'justify',
        isBulletList:    !!((list && list.tagName === 'UL')),
        isNumberList:    !!(list && list.tagName === 'OL'),
        isSubScript:     !!(((activeEditor) && activeEditor.queryCommandState('subscript'))),
        isSuperScript:   !!(((activeEditor) && activeEditor.queryCommandState('superscript'))),
      };

      this.$nextTick(() => {
        activeObject.valuesForLeftPanel = temp;
        let tempContent                 = '';
        activeEditor && (tempContent = activeEditor.getContent());

        if (activeEditor && activeObject && tempContent !== activeObject.modifiedHtml) {
          activeObject.modifiedHtml = tempContent;
          // const debounce = _.debounce(this.testDebounce, 3200, {trailing: true});
          setTimeout(() => {
            this.emitUndoRedoRequest('called by text property change');
          }, 10);
        }
      });
    },
    setParentHeightAccordingToText(activeObject) {
      const element = document.getElementById(activeObject.Id);
      if (element) {
        const parentComputedHeight = window.getComputedStyle(element)
          .getPropertyValue('height');
        const childComputedHeight  = window.getComputedStyle(element.firstElementChild)
          .getPropertyValue('height');
        if (parseInt(parentComputedHeight) < parseInt(childComputedHeight)) {
          activeObject.Height = parseInt(childComputedHeight) + 1;
          setTimeout(() => {
            EventBus.$emit(ApplicationEventTypes.ObjectSelectionEvents.UPDATED);
          }, 100);
        }
      }
    },
    setParentHeightAccordingToChildElement(activeObject) {
      const element = document.getElementById(activeObject.Id);
      if (element) {
        const parentComputedHeight = window.getComputedStyle(element)
          .getPropertyValue('height');
        const childComputedHeight  = window.getComputedStyle(element.firstElementChild)
          .getPropertyValue('height');
        if (parseInt(parentComputedHeight) > parseInt(childComputedHeight)) {
          activeObject.Height = parseInt(childComputedHeight) + 1;
          setTimeout(() => {
            EventBus.$emit(ApplicationEventTypes.ObjectSelectionEvents.UPDATED);
          }, 100);
          // EventBus.$emit(ApplicationEventTypes.ObjectSelectionEvents.UPDATED);
        }
      }
    },
    setDivAlignment(element, alignment) {
      if (!element) { return; }
      const divNode = element.querySelectorAll('div');
      for (let node = 0; node < divNode.length; node++) {
        divNode[node].style.textAlign = alignment;
      }
    },
    getElementFullSelectionRange(element) {
      window.getSelection()
        .removeAllRanges();
      const range = document.createRange();
      range.selectNodeContents(element);
      return range;
    },
    rgb2hex(rgb) {
      return `#${rgb.match(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/).slice(1).map(n => parseInt(n, 10).toString(16).padStart(2, '0')).join('')}`;
    },
    emitUndoRedoRequest(data) {
      EventBus.$emit('addIntoPageWiseUndoRedoArray', data);
    },
  },
};
